<template>
  <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
    <h3 slot="header" class="mb-0 font-weight-500" v-if="create_new_status">Create New Status</h3>
    <h3 slot="header" class="mb-0 font-weight-500" v-if="update_status">Update Status</h3>

    <b-form @submit.prevent="submit" ref="statusForm">
      <b-row>
        <!-- FIELD STATUS -->
        <b-col cols="12" v-if="module != 'disbursement'">
          <b-form-group label="Status Type:">
            <el-select v-model="new_status.group_name" placeholder="Select">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </b-form-group>
        </b-col>

				<b-col cols="12" v-if="module != 'disbursement'">
          <b-form-group label="Parent Status:" v-if="new_status.group_name == 'Sub'">
            <el-select v-model="new_status.parent_id" placeholder="Select">
              <el-option v-for="item in main_status" :key="item.status_id" :label="item.status" :value="item.status_id">
              </el-option>
            </el-select>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Status:">
            <b-form-input v-model="new_status.name" type="text" required :readonly="(new_status.module == 'disbursement' && update_status)"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Tat Days:">
            <b-form-input v-model="new_status.tat_day" type="text" required></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox v-model="new_status.stop_tat">Stop TAT Tracking</b-form-checkbox>
        </b-col>

        <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
          <b-button variant="primary" type="submit" class="w-100" v-if="create_new_status">Create</b-button>
          <b-button variant="primary" type="submit" class="w-100" v-if="update_status">Update</b-button>
        </b-col>
      </b-row>
    </b-form>
  </modal>
</template>

<script>
import Modal from "@/components/Modal"
import { Select, Option, Checkbox } from 'element-ui';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import {
  helperFunctionMixin,
} from '@/assets/js/httpImports.js'

export default {
  props: [
    'create_new_status',
    'module',
    'update_status',
    'update_status_data',
  ],
  components: {
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
  },
  mixins: [
    helperFunctionMixin
  ],
  data() {
    return {
      new_status: {
        id: '',
        name: '',
        group_name: '',
        parent_id: '',
        tat_day: 0,
        stop_tat: 0
      },
      statusOptions: [{
        value: 'Main',
        label: 'Main'
      }, {
        value: 'Sub',
        label: 'Sub'
      }],
      main_status: [
        {
          status_id: 2,
          status: 'Completed'
        }
      ]
    }
  },
  computed: {
    show: {
      get() {
        return this.create_new_status || this.update_status;
      },
      set(newVal) {
        this.$emit('update:create_new_status', newVal);
        this.$emit('update:update_status', newVal);
      },
    },
  },
  created() {
  },
  watch: {
    "new_status.group_name"(newVal) {
      if (newVal == "main") {
        this.new_status.parent_id = null;
      }
    },
    update_status(newVal) {
      if (newVal) {
        this.new_status = this.update_status_data;
      }
    }
  },
  methods: {
    ...mapActions(useCommonStore, ['createStatus', 'updateStatus']),
    submit() {
      const params = {
        module: this.module,
        ...this.new_status
      };
      if (this.new_status.id) {
        this.updateStatus(this.new_status.id, params).then((resp) => {
          _gNotif.notifySuccess('<b>Status</b> - Successfully Updated.')
          this.$emit('closeModal');
        });
      } else {
        this.createStatus(params).then((resp) => {
          _gNotif.notifySuccess('<b>Status</b> - Successfully Created.')
          this.$emit('closeModal');
        });
      }
    },
  }
}
</script>